import Axios from '@/api/http'
// 导航获取
export function gettasksystemlist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettasksystemlist',
    data: query
  })
}

/**
 * 任务接收人
 * */

// 获取任务接收人列表
export function gettaskreceivelist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettaskreceivelist',
    data: query
  })
}

// 添加任务接收人
export function addbatchtaskreceive(query) {
  return Axios({
    method: 'post',
    url: '/openapi/addbatchtaskreceive',
    data: query
  })
}

// 添加任务名单人员
export function openapiAddtaskreceive(query) {
  return Axios({
    method: 'post',
    url: '/openapi/addtaskreceive',
    data: query
  })
}

// 删除任务接收人
export function deletetaskreceive(query) {
  return Axios({
    method: 'post',
    url: '/openapi/deletetaskreceive',
    data: query
  })
}

/**
 * 任务参数
 * */

// 添加任务策略
export function addtaskconfig(query) {
  return Axios({
    method: 'post',
    url: '/openapi/addtaskconfig',
    data: query
  })
}

// 查询任务参数
export function gettaskconfig(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettaskconfig',
    data: query
  })
}

// 修改任务参数
export function updatetaskconfig(query) {
  return Axios({
    method: 'post',
    url: '/openapi/updatetaskconfig',
    data: query
  })
}

// 获取任务参数列表
export function gettaskconfiglist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettaskconfiglist',
    data: query
  })
}
// 转发任务
export function retransmissiontask(query) {
  return Axios({
    method: 'post',
    url: '/openapi/retransmissiontask',
    data: query
  })
}
// 批量转发任务
export function batchforwardtask(query) {
  return Axios({
    method: 'post',
    url: '/openapi/batchforwardtask',
    data: query
  })
}

// 删除任务参数
export function deletetaskconfig(query) {
  return Axios({
    method: 'post',
    url: '/openapi/deletetaskconfig',
    data: query
  })
}

/**
 *  我发布的
 * */
// 发布任务
export function addtaskbar(query) {
  return Axios({
    method: 'post',
    url: '/openapi/addtaskbar',
    data: query
  })
}

// 我发布的列表
export function gettaskbardatalist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettaskbardatalist',
    data: query
  })
}

// 任务详情
export function gettaskbar(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettaskbar',
    data: query
  })
}

// 修改任务
export function updatetaskbar(query) {
  return Axios({
    method: 'post',
    url: '/openapi/updatetaskbar',
    data: query
  })
}

/**
 * 任务详情
 */

// 日志
export function gettaskloglist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/gettaskloglist',
    data: query
  })
}

// 列表进入任务详情
export function getuserexecutelist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserexecutelist',
    data: query
  })
}
// 查询转发任务人和任务执行人列表
export function getpersonlist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getpersonlist',
    data: query
  })
}
// 任务完结
export function updateuserexecute(query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserexecute',
    data: query
  })
}
// 删除执行人或转发人
export function deleteuserexecute(query) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteuserexecute',
    data: query
  })
}
// 添加执行人
export function adduserexecutor(query) {
  return Axios({
    method: 'post',
    url: '/openapi/adduserexecutor',
    data: query
  })
}

/**
 * 任务评审
 */

 // 任务评审列表
 export function gettaskbardatalists(query) {
    return Axios({
      method: 'post',
      url: '/openapi/gettaskbardatalists',
      data: query
    })
  }
 // 子任务评审列表
 export function getuserexecutedatalist(query) {
    return Axios({
      method: 'post',
      url: '/openapi/getuserexecutedatalist',
      data: query
    })
  }
  // 修改评分
  export function updateassessment(query) {
    return Axios({
      method: 'post',
      url: '/openapi/updateassessment',
      data: query
    })
  }
  // 获取任务列表应用名称筛选列表
  export function getrelationnamelist(query) {
    return Axios({
      method: 'post',
      url: '/openapi/getrelationnamelist',
      data: query
    })
  }
  // 结束任务
  export function updateendtaskbar(query) {
    return Axios({
      method: 'post',
      url: '/openapi/updateendtaskbar',
      data: query
    })
  }
  // 获取任务代办红点
  export function getremindtaskbar(query) {
    return Axios({
      method: 'post',
      url: '/openapi/getremindtaskbar',
      data: query
    })
  }
